export const showConferencePages = __YFG_SHOW_CONFERENCE_PAGES__;
